// useContextMenu.js
import { useContext } from 'react';
import ContextMenuContext from '../../../context/ContextMenuContext';

const useContextMenu = () => {
  const context = useContext(ContextMenuContext);
  if (!context) {
    throw new Error(
      'useContextMenu должен использоваться внутри ContextMenuProvider'
    );
  }
  return context;
};

export default useContextMenu;
